(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-service-note"] && !Shopify.designMode) return;
  try {
    // A link whose hash names an accordion row opens that row before scrolling
  // to it, so "terms below" lands on the terms and not on a closed heading.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.product-service-note__text a[href^="#"]');
    if (!link) return;
    const target = document.getElementById(link.getAttribute('href').slice(1));
    if (!target) return;
    if (target.tagName === 'DETAILS' && !target.open) target.open = true;
    event.preventDefault();
    target.scrollIntoView({ block: 'start', behavior: 'smooth' });
  });
  } catch(e) { console.error(e); }
})();

})();
